import { createAction, props } from '@ngrx/store';
import {
  ChangePasswordForm,
  ContactUsData,
  CreateUserPassword,
  DeactivateUserForm,
  ForgotPassword,
  ISearchRequest,
  LoginFromData,
  MapPropertySearchParams,
  MessagesList,
  MessagesRequest,
  MlsPropertyDetails,
  PropertySearch,
  ResetPassword,
  ScheduleTour,
  SendMessageRequest,
  SignupForm,
  TicketReplyData,
  UserDetails,
  VerifyEmailOTP,
  NewsletterSubscribe,
  ContactAgent,
  AgentPortfolio,
  PayrollSubmissions,
  PayrollDocuments,
  CreateOffMarketProperty,
  OffMarketProperty,
  RentalListing,
  RentalListingsRequest,
  RentalSearchRequest,
  MarketedPropertyListing,
  ListingPaymentInitiateRequest,
  ListingPaymentInitiateResponse,
  KycIdentitySessionResponse,
} from 'src/app/shared/models';

export enum ActionTypes {
  LOGIN_USER = '[User] Login User',
  LOGIN_USER_SUCCESS = '[User] Login User Success',
  LOGIN_USER_FAILURE = '[User] Login User Failure',

  SIGNOUT_CONFIRMED = '[User] Sign Out Confirmed',

  SIGN_UP_USER = '[User] Sign Up User',
  SIGN_UP_USER_SUCCESS = '[User] Sign Up User Success',
  SIGN_UP_USER_FAILURE = '[User] Sign Up User Failure',

  VERIFY_EMAIL_OTP = '[User] Verify Email OTP',
  VERIFY_EMAIL_OTP_SUCCESS = '[User] Verify Email OTP Success',
  VERIFY_EMAIL_OTP_FAILURE = '[User] Verify Email OTP Failure',

  GET_USER_DETAILS = '[User] Get User Details',
  GET_USER_DETAILS_FAILURE = '[User] Get User Details Failure',
  GET_USER_DETAILS_SUCCESS = '[User] Get User Details Success',

  LOGOUT_CONFIRMED = 'Logout Confirmed',

  FORGOT_PASSWORD = '[User] Forgot Password',
  FORGOT_PASSWORD_SUCCESS = '[User] Forgot Password Success',
  FORGOT_PASSWORD_FAILURE = '[User] Forgot Password Failure',

  RESET_PASSWORD = '[User] Reset Password',
  RESET_PASSWORD_SUCCESS = '[User] Reset Password Success',
  RESET_PASSWORD_FAILURE = '[User] Reset Password Failure',

  UPDATE_USER_PROFILE_IMAGE = '[User] Update User Profile Image',
  UPDATE_USER_PROFILE_IMAGE_SUCCESS = '[User] Update User Profile Image Success',
  UPDATE_USER_PROFILE_IMAGE_FAILURE = '[User] Upadte User Profile Image Failure',

  UPDATE_USER_PROFILE_DETAILS = '[User] Update User Profile Details',
  UPDATE_USER_PROFILE_DETAILS_SUCCESS = '[User] Update User Profile Details Success',
  UPDATE_USER_PROFILE_DETAILS_FAILURE = '[User] Upadte User Profile Details Failure',

  DELETE_USER_PROFILE_IMAGE = '[User] Delete User Profile Image',
  DELETE_USER_PROFILE_IMAGE_SUCCESS = '[User] Delete User Profile Image Success',
  DELETE_USER_PROFILE_IMAGE_FAILURE = '[User] Delete User Profile Image Failure',

  DEACTIVATE_USER = '[User] Deactivate User',
  DEACTIVATE_USER_SUCCESS = '[User] Deactivate User Success',
  DEACTIVATE_USER_FAILURE = '[User] Deactivate User Failure',

  CHANGE_PASSWORD = '[User] Change Password',
  CHANGE_PASSWORD_SUCCESS = '[User] Change Password Success',
  CHANGE_PASSWORD_FAILURE = '[User] Change Password Failure',

  CREATE_USER_PASSWORD = '[User] Create User Password',
  CREATE_USER_PASSWORD_SUCCESS = '[User] Create User Password Success',
  CREATE_USER_PASSWORD_FAILURE = '[User] Create User Password Failure',

  GET_USER_PROPERTIES = '[User] Get User Properties',
  GET_USER_PROPERTIES_SUCCESS = '[User] Get User Properties Success',
  GET_USER_PROPERTIES_FAILURE = '[User] Get User Properties Failure',

  GET_MAP_PROPERTIES = '[User] Get Map Properties',
  GET_MAP_PROPERTIES_SUCCESS = '[User] Get Map Properties Success',
  GET_MAP_PROPERTIES_FAILURE = '[User] Get Map Properties Failure',

  GET_USER_WISHLIST = '[User] Get User Wish List',
  GET_USER_WISHLIST_SUCCESS = '[User] Get User Wish List Success',
  GET_USER_WISHLIST_FAILURE = '[User] Get User Wish List Failure',

  ADD_PROPERTY_TO_WISHLIST = '[User] Add Property to Wish List',
  ADD_PROPERTY_TO_WISHLIST_SUCCESS = '[User] Add Property to Wish List Success',
  ADD_PROPERTY_TO_WISHLIST_FAILURE = '[User] Add Property to Wish List Failure',

  REMOVE_PROPERTY_FROM_WISHLIST = '[User] Remove Property from Wish List',
  REMOVE_PROPERTY_FROM_WISHLIST_SUCCESS = '[User] Remove Property from Wish List Success',
  REMOVE_PROPERTY_FROM_WISHLIST_FAILURE = '[User] Remove Property from Wish List Failure',

  GET_ADDED_PROPERTY_IN_WISHLIST = '[User] Get Added Property in Wish List',
  GET_ADDED_PROPERTY_IN_WISHLIST_SUCCESS = '[User] Get Added Property in Wish List Success',
  GET_ADDED_PROPERTY_IN_WISHLIST_FAILURE = '[User] Get Added Property in Wish List Failure',

  ADD_PROPERTY = '[User] Add Property',
  ADD_PROPERTY_SUCCESS = '[User] Add Property Success',
  ADD_PROPERTY_FAILURE = '[User] Add Property Failure',

  SUBMIT_PROPERTY_FOR_APPROVAL = '[User] Submit Property For Approval',
  SUBMIT_PROPERTY_FOR_APPROVAL_SUCCESS = '[User] Submit Property For Approval Success',
  SUBMIT_PROPERTY_FOR_APPROVAL_FAILURE = '[User] Submit Property For Approval Failure',

  REMOVE_USER_PROPERTY = '[User] Remove User Property',
  REMOVE_USER_PROPERTY_SUCCESS = '[User] Remove User Property Success',
  REMOVE_USER_PROPERTY_FAILURE = '[User] Remove User Property Failure',

  INITIATE_MARKETED_LISTING_PAYMENT = '[User] Initiate Marketed Listing Payment',
  INITIATE_MARKETED_LISTING_PAYMENT_SUCCESS = '[User] Initiate Marketed Listing Payment Success',
  INITIATE_MARKETED_LISTING_PAYMENT_FAILURE = '[User] Initiate Marketed Listing Payment Failure',

  GET_PROPERTY_DETAILS = '[User] Get Property Details',
  GET_PROPERTY_DETAILS_SUCCESS = '[User] Get Property Details',
  GET_PROPERTY_DETAILS_FAILURE = '[User] Get Property Details Failure',

  GET_ARIS_MARKETED_PROPERTY_DETAILS = '[User] Get Aris Marketed Property Details',
  GET_ARIS_MARKETED_PROPERTY_DETAILS_SUCCESS = '[User] Get Aris Marketed Property Details Success',
  GET_ARIS_MARKETED_PROPERTY_DETAILS_FAILURE = '[User] Get Aris Marketed Property Details Failure',

  GET_USER_TICKETS = '[User] Get User Tickets',
  GET_USER_TICKETS_SUCCESS = '[User] Get User Tickets Success',
  GET_USER_TICKETS_FAILURE = '[User] Get User Tickets Failure',

  CREATE_USER_TICKET = '[User] Create User Ticket',
  CREATE_USER_TICKET_SUCCESS = '[User] Create User Ticket Success',
  CREATE_USER_TICKET_FAILURE = '[User] Create User Ticket Failure',

  DELETE_USER_TICKET = '[User] Delete User Ticket',
  DELETE_USER_TICKET_SUCCESS = '[User] Delete User Ticket Success',
  DELETE_USER_TICKET_FAILURE = '[User] Delete User Ticket Failure',

  UPDATE_USER_TICKET_STATUS = '[User] Update User Ticket Status',
  UPDATE_USER_TICKET_STATUS_SUCCESS = '[User] Update User Ticket Status Success',
  UPDATE_USER_TICKET_STATUS_FAILURE = '[User] Update User Ticket Status Failure',

  GET_USER_TICKET_DETAILS = '[User] Get User Ticket Details',
  GET_USER_TICKET_DETAILS_SUCCESS = '[User] Get User Ticket Details Success',
  GET_USER_TICKET_DETAILS_FAILURE = '[User] Get User Ticket Details Failure',

  GET_USER_TICKET_REPLIES = '[User] Get User Ticket Replies',
  GET_USER_TICKET_REPLIES_SUCCESS = '[User] Get User Ticket Replies Success',
  GET_USER_TICKET_REPLIES_FAILURE = '[User] Get User Ticket Replies Failure',

  ADD_USER_TICKET_REPLY = '[User] Add User Ticket Reply',
  ADD_USER_TICKET_REPLY_SUCCESS = '[User] Add User Ticket Reply Success',
  ADD_USER_TICKET_REPLY_FAILURE = '[User] Add User Ticket Reply Failure',

  GET_AGENT_LEADS = '[Agent] Get Agent Leads',
  GET_AGENT_LEADS_SUCCESS = '[Agent] Get Agent Leads Success',
  GET_AGENT_LEADS_FAILURE = '[Agent] Get Agent Leads Failure',

  GET_MARKETED_AGENT_LEADS = '[Agent] Get Marketed Agent Leads',
  GET_MARKETED_AGENT_LEADS_SUCCESS = '[Agent] Get Marketed Agent Leads Success',
  GET_MARKETED_AGENT_LEADS_FAILURE = '[Agent] Get Marketed Agent Leads Failure',

  UPDATE_AGENT_LEAD_STATUS = '[Agent] Update Agent Lead Status',
  UPDATE_AGENT_LEAD_STATUS_SUCCESS = '[Agent] Update Agent Lead Status Success',
  UPDATE_AGENT_LEAD_STATUS_FAILURE = '[Agent] Update Agent Lead Status Failure',

  GET_AGENT_APPOINTMENTS = '[Agent] Get Agent Appointments',
  GET_AGENT_APPOINTMENTS_SUCCESS = '[Agent] Get Agent Appointments Success',
  GET_AGENT_APPOINTMENTS_FAILURE = '[Agent] Get Agent Appointments Failure',

  UPDATE_AGENT_APPOINTMENT_STATUS = '[Agent] Update Agent Appointment Status',
  UPDATE_AGENT_APPOINTMENT_STATUS_SUCCESS = '[Agent] Update Agent Appointment Status Success',
  UPDATE_AGENT_APPOINTMENT_STATUS_FAILURE = '[Agent] Update Agent Appointment Status Failure',

  SEARCH_PROPERTIES = '[User] Search Properties',
  SEARCH_PROPERTIES_SUCCESS = '[User] Search Properties Success',
  SEARCH_PROPERTIES_FAILURE = '[User] Search Properties Failure',

  SET_SEARCH_PROPERTY_REQUEST = '[User] Set Search Properties Request',

  GET_MLS_PROPERTY_DETAILS = '[User] Get Mls Property Details',
  GET_MLS_PROPERTY_DETAILS_SUCCESS = '[User] Get Mls Property Details Success',
  GET_MLS_PROPERTY_DETAILS_FAILURE = '[User] Get Mls Property Details Failure',

  SCHEDULE_A_TOUR = '[User] Schedule A Tour',
  SCHEDULE_A_TOUR_SUCCESS = '[User] Schedule A Tour Success',
  SCHEDULE_A_TOUR_FAILURE = '[User] Schedule A Tour Failure',
  SCHEDULE_MARKETED_PROPERTY_TOUR = '[User] Schedule Marketed Property Tour',
  SCHEDULE_MARKETED_PROPERTY_TOUR_SUCCESS = '[User] Schedule Marketed Property Tour Success',
  SCHEDULE_MARKETED_PROPERTY_TOUR_FAILURE = '[User] Schedule Marketed Property Tour Failure',
  CONTACT_US = 'CONTACT_US',
  CONTACT_US_SUCCESS = 'CONTACT_US_SUCCESS',
  CONTACT_US_FAILURE = 'CONTACT_US_FAILURE',
  RESET_CONTACT_FORM = 'RESET_CONTACT_FORM',

  GET_USER_SCHEDULED_TOURS = '[User] Get User Scheduled Tours',
  GET_USER_SCHEDULED_TOURS_SUCCESS = '[User] Get User Scheduled Tours Success',
  GET_USER_SCHEDULED_TOURS_FAILURE = '[User] Get User Scheduled Tours Failure',

  GET_MESSAGES = '[User] Get Messages',
  GET_MESSAGES_SUCCESS = '[User] Get Messages Success',
  GET_MESSAGES_FAILURE = '[User] Get Messages Failure',

  SEND_MESSAGES = '[User] Send Messages',
  SEND_MESSAGES_SUCCESS = '[User] Send Messages Success',
  SEND_MESSAGES_FAILURE = '[User] Send Messages Failure',

  SET_MESSAGES = '[User] Set Messages',

  GET_MESSAGES_LIST = '[User] Get Messages List',
  GET_MESSAGES_LIST_SUCCESS = '[User] Get Messages List Success',
  GET_MESSAGES_LIST_FAILURE = '[User] Get Messages List Failure',

  GET_USER_BY_ID = '[User] Get User By Id',
  GET_USER_BY_ID_SUCCESS = '[User] Get User By Id Success',
  GET_USER_BY_ID_FAILURE = '[User] Get User By Id Failure',

  GET_BLOGS_LIST = '[Home] Get Blogs List',
  GET_BLOGS_LIST_SUCCESS = '[Home] Get Blogs List Success',
  GET_BLOGS_LIST_FAILURE = '[Home] Get Blogs List Failure',

  GET_BLOG_BY_ID = '[Home] Get Blog By Id',
  GET_BLOG_BY_ID_SUCCESS = '[Home] Get Blog By Id Success',
  GET_BLOG_BY_ID_FAILURE = '[Home] Get Blog By Id Failure',

  REGISTER_AGENT = '[Agent] Register Agent',
  REGISTER_AGENT_SUCCESS = '[Agent] Register Agent Success',
  REGISTER_AGENT_FAILURE = '[Agent] Register Agent Failure',

  GET_All_Register_AGENTS = '[Agent] Get All Registered Agents',
  GET_All_Register_AGENTS_SUCCESS = '[Agent] Get All Registered Agents Success',
  GET_All_Register_AGENTS_FAILURE = '[Agent] Get All Registered Agents Failure',
  GET_AGENT_BY_ID = '[Agent] Get Agent By Id',

  SET_LOADING_STATE = '[User] Set Loading State',

  GET_YOUTUBE_VIDEOS = '[User] Get Youtube Videos',
  GET_YOUTUBE_VIDEOS_SUCCESS = '[User] Get Youtube Videos Success',
  GET_YOUTUBE_VIDEOS_FAILURE = '[User] Get Youtube Videos Failure',

  GET_INSTAGRAM_POSTS = '[User] Get Instagram Posts',
  GET_INSTAGRAM_POSTS_SUCCESS = '[User] Get Instagram Posts Success',
  GET_INSTAGRAM_POSTS_FAILURE = '[User] Get Instagram Posts Failure',

  GET_TWITTER_POSTS = '[User] Get Twitter Posts',
  GET_TWITTER_POSTS_SUCCESS = '[User] Get Twitter Posts Success',
  GET_TWITTER_POSTS_FAILURE = '[User] Get Twitter Posts Failure',

  NEWSLETTER_SUBSCRIBE = '[User] Newsletter Subscribe',
  NEWSLETTER_SUBSCRIBE_SUCCESS = '[User] Newsletter Subscribe Success',
  NEWSLETTER_SUBSCRIBE_FAILURE = '[User] Newsletter Subscribe Failure',

  CONTACT_AGENT = '[Agent] Contact Agent',
  CONTACT_AGENT_SUCCESS = '[Agent] Contact Agent Success',
  CONTACT_AGENT_FAILURE = '[Agent] Contact Agent Failure',

  GET_AGENT_CONTACT_QUERIES = '[Agent] Get Agent Contact Queries',
  GET_AGENT_CONTACT_QUERIES_SUCCESS = '[Agent] Get Agent Contact Queries Success',
  GET_AGENT_CONTACT_QUERIES_FAILURE = '[Agent] Get Agent Contact Queries Failure',

  GET_AGENT_PORTFOLIO = '[Agent] Get Agent Portfolio',
  GET_AGENT_PORTFOLIO_SUCCESS = '[Agent] Get Agent Portfolio Success',
  GET_AGENT_PORTFOLIO_FAILURE = '[Agent] Get Agent Portfolio Failure',

  UPDATE_AGENT_PORTFOLIO = '[Agent] Update Agent Portfolio',
  UPDATE_AGENT_PORTFOLIO_SUCCESS = '[Agent] Update Agent Portfolio Success',
  UPDATE_AGENT_PORTFOLIO_FAILURE = '[Agent] Update Agent Portfolio Failure',

  GET_AGENT_PAYROLL_SUBMISSIONS = '[Agent] Get Agent Payroll Submissions',
  GET_AGENT_PAYROLL_SUBMISSIONS_SUCCESS = '[Agent] Get Agent Payroll Submissions Success',
  GET_AGENT_PAYROLL_SUBMISSIONS_FAILURE = '[Agent] Get Agent Payroll Submissions Failure',

  GET_AGENT_PAYROLL_SUBMISSION_DETAILS = '[Agent] Get Agent Payroll Submission Details',
  GET_AGENT_PAYROLL_SUBMISSION_DETAILS_SUCCESS = '[Agent] Get Agent Payroll Submission Details Success',
  GET_AGENT_PAYROLL_SUBMISSION_DETAILS_FAILURE = '[Agent] Get Agent Payroll Submission Details Failure',

  CREATE_AGENT_PAYROLL_REQUEST = '[Agent] Create Agent Payroll Request',
  CREATE_AGENT_PAYROLL_REQUEST_SUCCESS = '[Agent] Create Agent Payroll Request Success',
  CREATE_AGENT_PAYROLL_REQUEST_FAILURE = '[Agent] Create Agent Payroll Request Failure',

  UPDATE_AGENT_PAYROLL_REQUEST = '[Agent] Update Agent Payroll Request',
  UPDATE_AGENT_PAYROLL_REQUEST_SUCCESS = '[Agent] Update Agent Payroll Request Success',
  UPDATE_AGENT_PAYROLL_REQUEST_FAILURE = '[Agent] Update Agent Payroll Request Failure',

  DELETE_AGENT_PAYROLL_SUBMISSION = '[Agent] Delete Agent Payroll Submission',
  DELETE_AGENT_PAYROLL_SUBMISSION_SUCCESS = '[Agent] Delete Agent Payroll Submission Success',
  DELETE_AGENT_PAYROLL_SUBMISSION_FAILURE = '[Agent] Delete Agent Payroll Submission Failure',

  UPLOAD_AGENT_PAYROLL_DOCUMENTS = '[Agent] Upload Agent Payroll Documents',
  UPLOAD_AGENT_PAYROLL_DOCUMENTS_SUCCESS = '[Agent] Upload Agent Payroll Documents Success',
  UPLOAD_AGENT_PAYROLL_DOCUMENTS_FAILURE = '[Agent] Upload Agent Payroll Documents Failure',

  CLEAR_PAYROLL_SUBMISSION_DETAILS = '[Agent] Clear Payroll Submission Details',

  DELETE_AGENT_PAYROLL_ATTACHMENT = '[Agent] Delete Agent Payroll Attachment',
  DELETE_AGENT_PAYROLL_ATTACHMENT_SUCCESS = '[Agent] Delete Agent Payroll Attachment Success',
  DELETE_AGENT_PAYROLL_ATTACHMENT_FAILURE = '[Agent] Delete Agent Payroll Attachment Failure',

  GET_AGENT_OFF_MARKET_PROPERTIES = '[Agent] Get Agent Off Market Properties',
  GET_AGENT_OFF_MARKET_PROPERTIES_SUCCESS = '[Agent] Get Agent Off Market Properties Success',
  GET_AGENT_OFF_MARKET_PROPERTIES_FAILURE = '[Agent] Get Agent Off Market Properties Failure',

  GET_AGENT_OFF_MARKET_PROPERTY_DETAILS = '[Agent] Get Agent Off Market Property Details',
  GET_AGENT_OFF_MARKET_PROPERTY_DETAILS_SUCCESS = '[Agent] Get Agent Off Market Property Details Success',
  GET_AGENT_OFF_MARKET_PROPERTY_DETAILS_FAILURE = '[Agent] Get Agent Off Market Property Details Failure',

  CREATE_AGENT_OFF_MARKET_PROPERTY = '[Agent] Create Agent Off Market Property',
  CREATE_AGENT_OFF_MARKET_PROPERTY_SUCCESS = '[Agent] Create Agent Off Market Property Success',
  CREATE_AGENT_OFF_MARKET_PROPERTY_FAILURE = '[Agent] Create Agent Off Market Property Failure',

  UPDATE_AGENT_OFF_MARKET_PROPERTY = '[Agent] Update Agent Off Market Property',
  UPDATE_AGENT_OFF_MARKET_PROPERTY_SUCCESS = '[Agent] Update Agent Off Market Property Success',
  UPDATE_AGENT_OFF_MARKET_PROPERTY_FAILURE = '[Agent] Update Agent Off Market Property Failure',

  DELETE_AGENT_OFF_MARKET_PROPERTY = '[Agent] Delete Agent Off Market Property',
  DELETE_AGENT_OFF_MARKET_PROPERTY_SUCCESS = '[Agent] Delete Agent Off Market Property Success',
  DELETE_AGENT_OFF_MARKET_PROPERTY_FAILURE = '[Agent] Delete Agent Off Market Property Failure',

  UPLOAD_AGENT_OFF_MARKET_PROPERTY_DOCUMENTS = '[Agent] Upload Agent Off Market Property Documents',
  UPLOAD_AGENT_OFF_MARKET_PROPERTY_DOCUMENTS_SUCCESS = '[Agent] Upload Agent Off Market Property Documents Success',
  UPLOAD_AGENT_OFF_MARKET_PROPERTY_DOCUMENTS_FAILURE = '[Agent] Upload Agent Off Market Property Documents Failure',

  DELETE_AGENT_OFF_MARKET_PROPERTY_DOCUMENT = '[Agent] Delete Agent Off Market Property Document',
  DELETE_AGENT_OFF_MARKET_PROPERTY_DOCUMENT_SUCCESS = '[Agent] Delete Agent Off Market Property Document Success',
  DELETE_AGENT_OFF_MARKET_PROPERTY_DOCUMENT_FAILURE = '[Agent] Delete Agent Off Market Property Document Failure',

  GENERATE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK = '[Agent] Generate Agent Off Market Property Share Link',
  GENERATE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS = '[Agent] Generate Agent Off Market Property Share Link Success',
  GENERATE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE = '[Agent] Generate Agent Off Market Property Share Link Failure',

  REVOKE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK = '[Agent] Revoke Agent Off Market Property Share Link',
  REVOKE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS = '[Agent] Revoke Agent Off Market Property Share Link Success',
  REVOKE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE = '[Agent] Revoke Agent Off Market Property Share Link Failure',

  GET_SHARED_OFF_MARKET_PROPERTY = '[Agent] Get Shared Off Market Property',
  GET_SHARED_OFF_MARKET_PROPERTY_SUCCESS = '[Agent] Get Shared Off Market Property Success',
  GET_SHARED_OFF_MARKET_PROPERTY_FAILURE = '[Agent] Get Shared Off Market Property Failure',

  CREATE_OR_UPDATE_RENTAL_LISTING = '[Rentals] Create Or Update Rental Listing',
  CREATE_OR_UPDATE_RENTAL_LISTING_SUCCESS = '[Rentals] Create Or Update Rental Listing Success',
  CREATE_OR_UPDATE_RENTAL_LISTING_FAILURE = '[Rentals] Create Or Update Rental Listing Failure',

  GET_RENTAL_LISTINGS = '[Rentals] Get Rental Listings',
  GET_RENTAL_LISTINGS_SUCCESS = '[Rentals] Get Rental Listings Success',
  GET_RENTAL_LISTINGS_FAILURE = '[Rentals] Get Rental Listings Failure',

  GET_RENTAL_LISTING_BY_ID = '[Rentals] Get Rental Listing By Id',
  GET_RENTAL_LISTING_BY_ID_SUCCESS = '[Rentals] Get Rental Listing By Id Success',
  GET_RENTAL_LISTING_BY_ID_FAILURE = '[Rentals] Get Rental Listing By Id Failure',

  GET_PUBLIC_RENTAL_LISTING_BY_ID = '[Rentals] Get Public Rental Listing By Id',
  GET_PUBLIC_RENTAL_LISTING_BY_ID_SUCCESS = '[Rentals] Get Public Rental Listing By Id Success',
  GET_PUBLIC_RENTAL_LISTING_BY_ID_FAILURE = '[Rentals] Get Public Rental Listing By Id Failure',

  SUBMIT_RENTAL_FOR_APPROVAL = '[Rentals] Submit Rental For Approval',
  SUBMIT_RENTAL_FOR_APPROVAL_SUCCESS = '[Rentals] Submit Rental For Approval Success',
  SUBMIT_RENTAL_FOR_APPROVAL_FAILURE = '[Rentals] Submit Rental For Approval Failure',

  DELETE_RENTAL_LISTING = '[Rentals] Delete Rental Listing',
  DELETE_RENTAL_LISTING_SUCCESS = '[Rentals] Delete Rental Listing Success',
  DELETE_RENTAL_LISTING_FAILURE = '[Rentals] Delete Rental Listing Failure',

  START_KYC_IDENTITY_SESSION = '[User] Start KYC Identity Session',
  START_KYC_IDENTITY_SESSION_SUCCESS = '[User] Start KYC Identity Session Success',
  START_KYC_IDENTITY_SESSION_FAILURE = '[User] Start KYC Identity Session Failure',
  START_KYC_PROFILE_POLLING = '[User] Start KYC Profile Polling',
  STOP_KYC_PROFILE_POLLING = '[User] Stop KYC Profile Polling',
  CHECK_KYC_PROFILE_STATUS = '[User] Check KYC Profile Status',
  CHECK_KYC_PROFILE_STATUS_SUCCESS = '[User] Check KYC Profile Status Success',
  CHECK_KYC_PROFILE_STATUS_FAILURE = '[User] Check KYC Profile Status Failure',
  KYC_PROFILE_POLLING_TIMED_OUT = '[User] KYC Profile Polling Timed Out',
  CLEAR_KYC_PROFILE_POLLING_STATE = '[User] Clear KYC Profile Polling State',
  SET_PENDING_RENTAL_SUBMIT_AFTER_KYC = '[Rentals] Set Pending Rental Submit After KYC',

  SEARCH_RENTAL_PROPERTIES = '[Rentals] Search Rental Properties',
  SEARCH_RENTAL_PROPERTIES_SUCCESS = '[Rentals] Search Rental Properties Success',
  SEARCH_RENTAL_PROPERTIES_FAILURE = '[Rentals] Search Rental Properties Failure',

  GET_RENTAL_MAP_MARKERS = '[Rentals] Get Rental Map Markers',
  GET_RENTAL_MAP_MARKERS_SUCCESS = '[Rentals] Get Rental Map Markers Success',
  GET_RENTAL_MAP_MARKERS_FAILURE = '[Rentals] Get Rental Map Markers Failure',

  GET_ARIS_MARKETED_PROPERTIES = '[User] Get Aris Marketed Properties',
  GET_ARIS_MARKETED_PROPERTIES_SUCCESS = '[User] Get Aris Marketed Properties Success',
  GET_ARIS_MARKETED_PROPERTIES_FAILURE = '[User] Get Aris Marketed Properties Failure',

  GET_ARIS_MARKETED_MAP_PROPERTIES = '[User] Get Aris Marketed Map Properties',
  GET_ARIS_MARKETED_MAP_PROPERTIES_SUCCESS = '[User] Get Aris Marketed Map Properties Success',
  GET_ARIS_MARKETED_MAP_PROPERTIES_FAILURE = '[User] Get Aris Marketed Map Properties Failure',

  MARK_AS_SOLD = '[User] Mark As Sold',
  MARK_AS_SOLD_SUCCESS = '[User] Mark As Sold Success',
  MARK_AS_SOLD_FAILURE = '[User] Mark As Sold Failure',
}

export const signUp = createAction(
  ActionTypes.SIGN_UP_USER,
  props<{ data: SignupForm }>(),
);

export const signUpSuccess = createAction(
  ActionTypes.SIGN_UP_USER_SUCCESS,
  props<{ data: any }>(),
);
export const signUpFailure = createAction(
  ActionTypes.SIGN_UP_USER_FAILURE,
  props<{ error: any }>(),
);

export const setLoadingState = createAction(
  ActionTypes.SET_LOADING_STATE,
  props<{ isLoading: boolean }>(),
);

export const login = createAction(
  ActionTypes.LOGIN_USER,
  props<{ payload: LoginFromData }>(),
);

export const loginSuccess = createAction(ActionTypes.LOGIN_USER_SUCCESS);

export const loginFailure = createAction(
  ActionTypes.LOGIN_USER_FAILURE,
  props<{ error: string }>(),
);

export const signOutConfirmed = createAction(ActionTypes.SIGNOUT_CONFIRMED);

export const getUserDetails = createAction(ActionTypes.GET_USER_DETAILS);

export const getUserDetailsSuccess = createAction(
  ActionTypes.GET_USER_DETAILS_SUCCESS,
  props<{ payload: UserDetails }>(),
);

export const getUserDetailsFailure = createAction(
  ActionTypes.GET_USER_DETAILS_FAILURE,
  props<{ error: string }>(),
);

export const verifyEmailOtp = createAction(
  ActionTypes.VERIFY_EMAIL_OTP,
  props<{ payload: VerifyEmailOTP }>(),
);

export const verifyEmailOtpSuccess = createAction(
  ActionTypes.VERIFY_EMAIL_OTP_SUCCESS,
);

export const verifyEmailOtpFailure = createAction(
  ActionTypes.VERIFY_EMAIL_OTP_FAILURE,
  props<{ error: any }>(),
);

export const updateUserProfileDetails = createAction(
  ActionTypes.UPDATE_USER_PROFILE_DETAILS,
  props<{ payload: UserDetails }>(),
);

export const updateUserProfileDetailsSuccess = createAction(
  ActionTypes.UPDATE_USER_PROFILE_DETAILS_SUCCESS,
  props<{ payload: any }>(),
);

export const updateUserProfileDetailsFailure = createAction(
  ActionTypes.UPDATE_USER_PROFILE_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const updateUserProfileImage = createAction(
  ActionTypes.UPDATE_USER_PROFILE_IMAGE,
  props<{ payload: File }>(),
);

export const updateUserProfileImageSuccess = createAction(
  ActionTypes.UPDATE_USER_PROFILE_IMAGE_SUCCESS,
  props<{ payload: any }>(),
);

export const updateUserProfileImageFailure = createAction(
  ActionTypes.UPDATE_USER_PROFILE_IMAGE_FAILURE,
  props<{ error: any }>(),
);

export const deleteUserProfileImage = createAction(
  ActionTypes.DELETE_USER_PROFILE_IMAGE,
);

export const deleteUserProfileImageSuccess = createAction(
  ActionTypes.DELETE_USER_PROFILE_IMAGE_SUCCESS,
);

export const deleteUserProfileImageFailure = createAction(
  ActionTypes.DELETE_USER_PROFILE_IMAGE_FAILURE,
  props<{ error: any }>(),
);

export const deactivateUser = createAction(
  ActionTypes.DEACTIVATE_USER,
  props<{ payload: DeactivateUserForm }>(),
);

export const deactivateUserSuccess = createAction(
  ActionTypes.DEACTIVATE_USER_SUCCESS,
);

export const deactivateUserFailure = createAction(
  ActionTypes.DEACTIVATE_USER_FAILURE,
  props<{ error: any }>(),
);

export const createUserPassword = createAction(
  ActionTypes.CREATE_USER_PASSWORD,
  props<{ data: CreateUserPassword }>(),
);

export const createUserPasswordSuccess = createAction(
  ActionTypes.CREATE_USER_PASSWORD_SUCCESS,
  props<{ data: any }>(),
);

export const createUserPasswordFailure = createAction(
  ActionTypes.CREATE_USER_PASSWORD_FAILURE,
  props<{ error: any }>(),
);

export const changePassword = createAction(
  ActionTypes.CHANGE_PASSWORD,
  props<{ data: ChangePasswordForm }>(),
);

export const changePasswordSuccess = createAction(
  ActionTypes.CHANGE_PASSWORD_SUCCESS,
  props<{ data: any }>(),
);

export const changePasswordFailure = createAction(
  ActionTypes.CHANGE_PASSWORD_FAILURE,
  props<{ error: any }>(),
);

export const getUserProperties = createAction(
  ActionTypes.GET_USER_PROPERTIES,
  props<{ data: ISearchRequest }>(),
);

export const getUserPropertiesSuccess = createAction(
  ActionTypes.GET_USER_PROPERTIES_SUCCESS,
  props<{ data: any }>(),
);

export const getUserPropertiesFailure = createAction(
  ActionTypes.GET_USER_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const getMapProperties = createAction(
  ActionTypes.GET_MAP_PROPERTIES,
  props<{ data: Partial<MapPropertySearchParams> }>(),
);

export const getMapPropertiesSuccess = createAction(
  ActionTypes.GET_MAP_PROPERTIES_SUCCESS,
  props<{ data: any }>(),
);

export const getMapPropertiesFailure = createAction(
  ActionTypes.GET_MAP_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const getUserWishlist = createAction(
  ActionTypes.GET_USER_WISHLIST,
  props<{ data: ISearchRequest }>(),
);

export const getUserWishlistSuccess = createAction(
  ActionTypes.GET_USER_WISHLIST_SUCCESS,
  props<{ data: any }>(),
);

export const getUserWishlistFailure = createAction(
  ActionTypes.GET_USER_WISHLIST_FAILURE,
  props<{ error: any }>(),
);

export const addPropertyToWishList = createAction(
  ActionTypes.ADD_PROPERTY_TO_WISHLIST,
  props<{ listingKey: string }>(),
);

export const addPropertyToWishListSuccess = createAction(
  ActionTypes.ADD_PROPERTY_TO_WISHLIST_SUCCESS,
  props<{ data: any }>(),
);

export const addPropertyToWishListFailure = createAction(
  ActionTypes.ADD_PROPERTY_TO_WISHLIST_FAILURE,
  props<{ error: any }>(),
);

export const removePropertyFromWishList = createAction(
  ActionTypes.REMOVE_PROPERTY_FROM_WISHLIST,
  props<{ listingKey: number; data: ISearchRequest }>(),
);

export const removePropertyFromWishListSuccess = createAction(
  ActionTypes.REMOVE_PROPERTY_FROM_WISHLIST_SUCCESS,
  props<{ data: any }>(),
);

export const removePropertyFromWishListFailure = createAction(
  ActionTypes.REMOVE_PROPERTY_FROM_WISHLIST_FAILURE,
  props<{ error: any }>(),
);

export const getAddedPropertyInWishList = createAction(
  ActionTypes.GET_ADDED_PROPERTY_IN_WISHLIST,
);

export const getAddedPropertyInWishListSuccess = createAction(
  ActionTypes.GET_ADDED_PROPERTY_IN_WISHLIST_SUCCESS,
  props<{ data: any }>(),
);

export const getAddedPropertyInWishListFailure = createAction(
  ActionTypes.GET_ADDED_PROPERTY_IN_WISHLIST_FAILURE,
  props<{ error: any }>(),
);

export const addProperty = createAction(
  ActionTypes.ADD_PROPERTY,
  props<{ data: MarketedPropertyListing; check: 'draft' | 'submit' }>(),
);

export const addPropertySuccess = createAction(
  ActionTypes.ADD_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const addPropertyFailure = createAction(
  ActionTypes.ADD_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const submitPropertyForApproval = createAction(
  ActionTypes.SUBMIT_PROPERTY_FOR_APPROVAL,
  props<{ id: number }>(),
);

export const submitPropertyForApprovalSuccess = createAction(
  ActionTypes.SUBMIT_PROPERTY_FOR_APPROVAL_SUCCESS,
  props<{ data: any }>(),
);

export const submitPropertyForApprovalFailure = createAction(
  ActionTypes.SUBMIT_PROPERTY_FOR_APPROVAL_FAILURE,
  props<{ error: any }>(),
);

export const deleteUserProperty = createAction(
  ActionTypes.REMOVE_USER_PROPERTY,
  props<{ propertyId: number; data: ISearchRequest }>(),
);

export const deleteUserPropertySuccess = createAction(
  ActionTypes.REMOVE_USER_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const deleteUserPropertyFailure = createAction(
  ActionTypes.REMOVE_USER_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const initiateMarketedListingPayment = createAction(
  ActionTypes.INITIATE_MARKETED_LISTING_PAYMENT,
  props<{ data: ListingPaymentInitiateRequest }>(),
);

export const initiateMarketedListingPaymentSuccess = createAction(
  ActionTypes.INITIATE_MARKETED_LISTING_PAYMENT_SUCCESS,
  props<{ data: ListingPaymentInitiateResponse }>(),
);

export const initiateMarketedListingPaymentFailure = createAction(
  ActionTypes.INITIATE_MARKETED_LISTING_PAYMENT_FAILURE,
  props<{ error: any }>(),
);

export const getUserPropertyDetails = createAction(
  ActionTypes.GET_PROPERTY_DETAILS,
  props<{ propertyId: string }>(),
);

export const getPropertyDetailsSuccess = createAction(
  ActionTypes.GET_PROPERTY_DETAILS_SUCCESS,
  props<{ data: MarketedPropertyListing }>(),
);

export const getPropertyDetailsFailure = createAction(
  ActionTypes.GET_PROPERTY_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const getArisMarketedPropertyDetails = createAction(
  ActionTypes.GET_ARIS_MARKETED_PROPERTY_DETAILS,
  props<{ propertyId: number }>(),
);

export const getArisMarketedPropertyDetailsSuccess = createAction(
  ActionTypes.GET_ARIS_MARKETED_PROPERTY_DETAILS_SUCCESS,
  props<{ data: MarketedPropertyListing }>(),
);

export const getArisMarketedPropertyDetailsFailure = createAction(
  ActionTypes.GET_ARIS_MARKETED_PROPERTY_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const getUserTickets = createAction(
  ActionTypes.GET_USER_TICKETS,
  props<{ data: ISearchRequest; role: 'Agent' | 'User' }>(),
);

export const getUserTicketsSuccess = createAction(
  ActionTypes.GET_USER_TICKETS_SUCCESS,
  props<{ data: any }>(),
);

export const getUserTicketsFailure = createAction(
  ActionTypes.GET_USER_TICKETS_FAILURE,
  props<{ error: any }>(),
);

export const createUserTicket = createAction(
  ActionTypes.CREATE_USER_TICKET,
  props<{ data: FormData }>(),
);

export const createUserTicketSuccess = createAction(
  ActionTypes.CREATE_USER_TICKET_SUCCESS,
  props<{ data: any }>(),
);

export const createUserTicketFailure = createAction(
  ActionTypes.CREATE_USER_TICKET_FAILURE,
  props<{ error: any }>(),
);

export const deleteUserTicket = createAction(
  ActionTypes.DELETE_USER_TICKET,
  props<{ id: number }>(),
);

export const deleteUserTicketSuccess = createAction(
  ActionTypes.DELETE_USER_TICKET_SUCCESS,
  props<{ data: any }>(),
);

export const deleteUserTicketFailure = createAction(
  ActionTypes.DELETE_USER_TICKET_FAILURE,
  props<{ error: any }>(),
);

export const updateUserTicketStatus = createAction(
  ActionTypes.UPDATE_USER_TICKET_STATUS,
  props<{ id: number; data: ISearchRequest; role: 'Agent' | 'User' }>(),
);

export const updateUserTicketStatusSuccess = createAction(
  ActionTypes.UPDATE_USER_TICKET_STATUS_SUCCESS,
  props<{ data: any }>(),
);

export const updateUserTicketStatusFailure = createAction(
  ActionTypes.UPDATE_USER_TICKET_STATUS_FAILURE,
  props<{ error: any }>(),
);

export const getTicketDetails = createAction(
  ActionTypes.GET_USER_TICKET_DETAILS,
  props<{ id: number }>(),
);

export const getTicketDetailsSuccess = createAction(
  ActionTypes.GET_USER_TICKET_DETAILS_SUCCESS,
  props<{ data: any }>(),
);

export const getTicketDetailsFailure = createAction(
  ActionTypes.GET_USER_TICKET_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const getTicketReplies = createAction(
  ActionTypes.GET_USER_TICKET_REPLIES,
  props<{ id: number }>(),
);

export const getTicketRepliesSuccess = createAction(
  ActionTypes.GET_USER_TICKET_REPLIES_SUCCESS,
  props<{ data: any }>(),
);

export const getTicketRepliesFailure = createAction(
  ActionTypes.GET_USER_TICKET_REPLIES_FAILURE,
  props<{ error: any }>(),
);

export const addTicketReply = createAction(
  ActionTypes.ADD_USER_TICKET_REPLY,
  props<{ data: TicketReplyData }>(),
);

export const addTicketReplySuccess = createAction(
  ActionTypes.ADD_USER_TICKET_REPLY_SUCCESS,
  props<{ data: any }>(),
);

export const addTicketReplyFailure = createAction(
  ActionTypes.ADD_USER_TICKET_REPLY_FAILURE,
  props<{ error: any }>(),
);

export const getAgentLeads = createAction(
  ActionTypes.GET_AGENT_LEADS,
  props<{ data: ISearchRequest }>(),
);

export const getAgentLeadsSuccess = createAction(
  ActionTypes.GET_AGENT_LEADS_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentLeadsFailure = createAction(
  ActionTypes.GET_AGENT_LEADS_FAILURE,
  props<{ error: any }>(),
);

export const getMarketedAgentLeads = createAction(
  ActionTypes.GET_MARKETED_AGENT_LEADS,
  props<{ data: ISearchRequest }>(),
);

export const getMarketedAgentLeadsSuccess = createAction(
  ActionTypes.GET_MARKETED_AGENT_LEADS_SUCCESS,
  props<{ data: any }>(),
);

export const getMarketedAgentLeadsFailure = createAction(
  ActionTypes.GET_MARKETED_AGENT_LEADS_FAILURE,
  props<{ error: any }>(),
);

export const updateAgentLeadStatus = createAction(
  ActionTypes.UPDATE_AGENT_LEAD_STATUS,
  props<{ id: number; data: ISearchRequest }>(),
);

export const updateAgentLeadStatusSuccess = createAction(
  ActionTypes.UPDATE_AGENT_LEAD_STATUS_SUCCESS,
  props<{ data: any }>(),
);

export const updateAgentLeadStatusFailure = createAction(
  ActionTypes.UPDATE_AGENT_LEAD_STATUS_FAILURE,
  props<{ error: any }>(),
);

export const getAgentAppointments = createAction(
  ActionTypes.GET_AGENT_APPOINTMENTS,
  props<{ data: ISearchRequest }>(),
);

export const getAgentAppointmentsSuccess = createAction(
  ActionTypes.GET_AGENT_APPOINTMENTS_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentAppointmentsFailure = createAction(
  ActionTypes.GET_AGENT_APPOINTMENTS_FAILURE,
  props<{ error: any }>(),
);

export const updateAgentAppointmentStatus = createAction(
  ActionTypes.UPDATE_AGENT_APPOINTMENT_STATUS,
  props<{ id: number; data: ISearchRequest }>(),
);

export const updateAgentAppointmentStatusSuccess = createAction(
  ActionTypes.UPDATE_AGENT_APPOINTMENT_STATUS_SUCCESS,
  props<{ data: any }>(),
);

export const updateAgentAppointmentStatusFailure = createAction(
  ActionTypes.UPDATE_AGENT_APPOINTMENT_STATUS_FAILURE,
  props<{ error: any }>(),
);

export const searchProperties = createAction(
  ActionTypes.SEARCH_PROPERTIES,
  props<{ data: PropertySearch }>(),
);

export const searchPropertiesSuccess = createAction(
  ActionTypes.SEARCH_PROPERTIES_SUCCESS,
  props<{ data: any }>(),
);

export const searchPropertiesFailure = createAction(
  ActionTypes.SEARCH_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const setSearchPropertyRequest = createAction(
  ActionTypes.SET_SEARCH_PROPERTY_REQUEST,
  props<{ data: PropertySearch }>(),
);

export const getMlsPropertyDetails = createAction(
  ActionTypes.GET_MLS_PROPERTY_DETAILS,
  props<{ propertyId: string }>(),
);

export const getMlsPropertyDetailsSuccess = createAction(
  ActionTypes.GET_MLS_PROPERTY_DETAILS_SUCCESS,
  props<{ data: MlsPropertyDetails }>(),
);

export const getMlsPropertyDetailsFailure = createAction(
  ActionTypes.GET_MLS_PROPERTY_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const scheduleATour = createAction(
  ActionTypes.SCHEDULE_A_TOUR,
  props<{ data: ScheduleTour }>(),
);

export const scheduleATourSuccess = createAction(
  ActionTypes.SCHEDULE_A_TOUR_SUCCESS,
  props<{ data: any }>(),
);

export const scheduleATourFailure = createAction(
  ActionTypes.SCHEDULE_A_TOUR_FAILURE,
  props<{ error: any }>(),
);

export const scheduleMarketedPropertyTour = createAction(
  ActionTypes.SCHEDULE_MARKETED_PROPERTY_TOUR,
  props<{ data: ScheduleTour }>(),
);

export const scheduleMarketedPropertyTourSuccess = createAction(
  ActionTypes.SCHEDULE_MARKETED_PROPERTY_TOUR_SUCCESS,
  props<{ data: any }>(),
);

export const scheduleMarketedPropertyTourFailure = createAction(
  ActionTypes.SCHEDULE_MARKETED_PROPERTY_TOUR_FAILURE,
  props<{ error: any }>(),
);

export const contactUs = createAction(
  ActionTypes.CONTACT_US,
  props<{ data: ContactUsData }>(),
);

export const contactUsSuccess = createAction(
  ActionTypes.CONTACT_US_SUCCESS,
  props<{ data: any }>(),
);

export const contactUsFailure = createAction(
  ActionTypes.CONTACT_US_FAILURE,
  props<{ error: any }>(),
);

export const resetContactForm = createAction(ActionTypes.RESET_CONTACT_FORM);

export const forgotPassword = createAction(
  ActionTypes.FORGOT_PASSWORD,
  props<{ data: ForgotPassword }>(),
);

export const forgotPasswordSuccess = createAction(
  ActionTypes.FORGOT_PASSWORD_SUCCESS,
  props<{ data: any }>(),
);
export const forgotPasswordFailure = createAction(
  ActionTypes.FORGOT_PASSWORD_FAILURE,
  props<{ error: any }>(),
);

export const resetPassword = createAction(
  ActionTypes.RESET_PASSWORD,
  props<{ payload: ResetPassword }>(),
);

export const resetPasswordSuccess = createAction(
  ActionTypes.RESET_PASSWORD_SUCCESS,
);

export const resetPasswordFailure = createAction(
  ActionTypes.RESET_PASSWORD_FAILURE,
  props<{ error: any }>(),
);

export const getUserScheduledTours = createAction(
  ActionTypes.GET_USER_SCHEDULED_TOURS,
  props<{ data: ISearchRequest }>(),
);

export const getUserScheduledToursSuccess = createAction(
  ActionTypes.GET_USER_SCHEDULED_TOURS_SUCCESS,
  props<{ data: any }>(),
);

export const getUserScheduledToursFailure = createAction(
  ActionTypes.GET_USER_SCHEDULED_TOURS_FAILURE,
  props<{ error: any }>(),
);

export const getMessages = createAction(
  ActionTypes.GET_MESSAGES,
  props<{ payload: MessagesRequest }>(),
);

export const getMessagesSuccess = createAction(
  ActionTypes.GET_MESSAGES_SUCCESS,
  props<{ data: any }>(),
);

export const getMessagesFailure = createAction(
  ActionTypes.GET_MESSAGES_FAILURE,
  props<{ error: any }>(),
);

export const sendMessage = createAction(
  ActionTypes.SEND_MESSAGES,
  props<{ payload: SendMessageRequest }>(),
);

export const sendMessageSuccess = createAction(
  ActionTypes.SEND_MESSAGES_SUCCESS,
  props<{ data: any }>(),
);

export const sendMessageFailure = createAction(
  ActionTypes.SEND_MESSAGES_FAILURE,
  props<{ error: any }>(),
);

export const setMessage = createAction(
  ActionTypes.SET_MESSAGES,
  props<{ data: SendMessageRequest }>(),
);

export const getMessagesList = createAction(
  ActionTypes.GET_MESSAGES_LIST,
  props<{ userId: string }>(),
);

export const getMessagesListSuccess = createAction(
  ActionTypes.GET_MESSAGES_LIST_SUCCESS,
  props<{ data: MessagesList[] }>(),
);

export const getMessagesListFailure = createAction(
  ActionTypes.GET_MESSAGES_LIST_FAILURE,
  props<{ error: any }>(),
);

export const getUserById = createAction(
  ActionTypes.GET_USER_BY_ID,
  props<{ userId: number }>(),
);

export const getUserByIdSuccess = createAction(
  ActionTypes.GET_USER_BY_ID_SUCCESS,
  props<{ data: any }>(),
);

export const getUserByIdFailure = createAction(
  ActionTypes.GET_USER_BY_ID_FAILURE,
  props<{ error: any }>(),
);

export const getBlogs = createAction(
  ActionTypes.GET_BLOGS_LIST,
  props<{ data: ISearchRequest }>(),
);

export const getBlogsSuccess = createAction(
  ActionTypes.GET_BLOGS_LIST_SUCCESS,
  props<{ data: any }>(),
);

export const getBlogsFailure = createAction(
  ActionTypes.GET_BLOGS_LIST_FAILURE,
  props<{ error: any }>(),
);

export const getBlogById = createAction(
  ActionTypes.GET_BLOG_BY_ID,
  props<{ blogId: number }>(),
);

export const getBlogByIdSuccess = createAction(
  ActionTypes.GET_BLOG_BY_ID_SUCCESS,
  props<{ data: any }>(),
);

export const getBlogByIdFailure = createAction(
  ActionTypes.GET_BLOG_BY_ID_FAILURE,
  props<{ error: any }>(),
);

export const addRegisterAgent = createAction(
  ActionTypes.REGISTER_AGENT,
  props<{ data: AgentPortfolio }>(),
);

export const addRegisterAgentSuccess = createAction(
  ActionTypes.REGISTER_AGENT_SUCCESS,
  props<{ data: any }>(),
);

export const addRegisterAgentFailure = createAction(
  ActionTypes.REGISTER_AGENT_FAILURE,
  props<{ error: any }>(),
);

export const getAllRegisterAgents = createAction(
  ActionTypes.GET_All_Register_AGENTS,
  props<{ data: ISearchRequest }>(),
);

export const getAllRegisterAgentsSuccess = createAction(
  ActionTypes.GET_All_Register_AGENTS_SUCCESS,
  props<{ data: any }>(),
);

export const getAllRegisterAgentsFailure = createAction(
  ActionTypes.GET_All_Register_AGENTS_FAILURE,
  props<{ error: any }>(),
);

export const getAgentById = createAction(
  ActionTypes.GET_AGENT_BY_ID,
  props<{ agentId: number }>(),
);

export const getAgentByIdSuccess = createAction(
  ActionTypes.GET_USER_BY_ID_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentByIdFailure = createAction(
  ActionTypes.GET_USER_BY_ID_FAILURE,
  props<{ error: any }>(),
);

export const markAsSold = createAction(
  ActionTypes.MARK_AS_SOLD,
  props<{ id: number; data: ISearchRequest }>(),
);

export const markAsSoldSuccess = createAction(
  ActionTypes.MARK_AS_SOLD_SUCCESS,
  props<{ data: any }>(),
);

export const markAsSoldFailure = createAction(
  ActionTypes.MARK_AS_SOLD_FAILURE,
  props<{ error: any }>(),
);

export const getYoutubeVideos = createAction(
  ActionTypes.GET_YOUTUBE_VIDEOS,
  props<{ max: number }>(),
);

export const getYoutubeVideosSuccess = createAction(
  ActionTypes.GET_YOUTUBE_VIDEOS_SUCCESS,
  props<{ data: any }>(),
);

export const getYoutubeVideosFailure = createAction(
  ActionTypes.GET_YOUTUBE_VIDEOS_FAILURE,
  props<{ error: any }>(),
);

export const getInstagramPosts = createAction(
  ActionTypes.GET_INSTAGRAM_POSTS,
  props<{ max: number }>(),
);

export const getInstagramPostsSuccess = createAction(
  ActionTypes.GET_INSTAGRAM_POSTS_SUCCESS,
  props<{ data: any }>(),
);

export const getInstagramPostsFailure = createAction(
  ActionTypes.GET_INSTAGRAM_POSTS_FAILURE,
  props<{ error: any }>(),
);

export const getTwitterPosts = createAction(
  ActionTypes.GET_TWITTER_POSTS,
  props<{ data: any }>(),
);

export const getTwitterPostsSuccess = createAction(
  ActionTypes.GET_TWITTER_POSTS_SUCCESS,
  props<{ data: any }>(),
);

export const getTwitterPostsFailure = createAction(
  ActionTypes.GET_TWITTER_POSTS_FAILURE,
  props<{ error: any }>(),
);

export const newsletterSubscribe = createAction(
  ActionTypes.NEWSLETTER_SUBSCRIBE,
  props<{ data: NewsletterSubscribe }>(),
);

export const newsletterSubscribeSuccess = createAction(
  ActionTypes.NEWSLETTER_SUBSCRIBE_SUCCESS,
  props<{ data: any }>(),
);

export const newsletterSubscribeFailure = createAction(
  ActionTypes.NEWSLETTER_SUBSCRIBE_FAILURE,
  props<{ error: any }>(),
);

export const contactAgent = createAction(
  ActionTypes.CONTACT_AGENT,
  props<{ data: ContactAgent }>(),
);

export const contactAgentSuccess = createAction(
  ActionTypes.CONTACT_AGENT_SUCCESS,
  props<{ data: any }>(),
);

export const contactAgentFailure = createAction(
  ActionTypes.CONTACT_AGENT_FAILURE,
  props<{ error: any }>(),
);

export const getAgentContactQueries = createAction(
  ActionTypes.GET_AGENT_CONTACT_QUERIES,
);

export const getAgentContactQueriesSuccess = createAction(
  ActionTypes.GET_AGENT_CONTACT_QUERIES_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentContactQueriesFailure = createAction(
  ActionTypes.GET_AGENT_CONTACT_QUERIES_FAILURE,
  props<{ error: any }>(),
);

export const getAgentPortfolio = createAction(ActionTypes.GET_AGENT_PORTFOLIO);

export const getAgentPortfolioSuccess = createAction(
  ActionTypes.GET_AGENT_PORTFOLIO_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentPortfolioFailure = createAction(
  ActionTypes.GET_AGENT_PORTFOLIO_FAILURE,
  props<{ error: any }>(),
);

export const updateAgentPortfolio = createAction(
  ActionTypes.UPDATE_AGENT_PORTFOLIO,
  props<{ data: FormData }>(),
);

export const updateAgentPortfolioSuccess = createAction(
  ActionTypes.UPDATE_AGENT_PORTFOLIO_SUCCESS,
  props<{ data: any }>(),
);

export const updateAgentPortfolioFailure = createAction(
  ActionTypes.UPDATE_AGENT_PORTFOLIO_FAILURE,
  props<{ error: any }>(),
);

export const getAgentPayrollSubmissions = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSIONS,
  props<{ data: ISearchRequest }>(),
);

export const getAgentPayrollSubmissionsSuccess = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSIONS_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentPayrollSubmissionsFailure = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSIONS_FAILURE,
  props<{ error: any }>(),
);

export const getAgentPayrollSubmissionDetails = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSION_DETAILS,
  props<{ id: number }>(),
);

export const getAgentPayrollSubmissionDetailsSuccess = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSION_DETAILS_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentPayrollSubmissionDetailsFailure = createAction(
  ActionTypes.GET_AGENT_PAYROLL_SUBMISSION_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const createAgentPayrollRequest = createAction(
  ActionTypes.CREATE_AGENT_PAYROLL_REQUEST,
  props<{ data: PayrollSubmissions }>(),
);

export const createAgentPayrollRequestSuccess = createAction(
  ActionTypes.CREATE_AGENT_PAYROLL_REQUEST_SUCCESS,
  props<{ data: PayrollSubmissions }>(),
);

export const createAgentPayrollRequestFailure = createAction(
  ActionTypes.CREATE_AGENT_PAYROLL_REQUEST_FAILURE,
  props<{ error: any }>(),
);

export const updateAgentPayrollRequest = createAction(
  ActionTypes.UPDATE_AGENT_PAYROLL_REQUEST,
  props<{ id: number; data: PayrollSubmissions; searchData: ISearchRequest }>(),
);

export const updateAgentPayrollRequestSuccess = createAction(
  ActionTypes.UPDATE_AGENT_PAYROLL_REQUEST_SUCCESS,
  props<{ data: any }>(),
);

export const updateAgentPayrollRequestFailure = createAction(
  ActionTypes.UPDATE_AGENT_PAYROLL_REQUEST_FAILURE,
  props<{ error: any }>(),
);

export const deleteAgentPayrollSubmission = createAction(
  ActionTypes.DELETE_AGENT_PAYROLL_SUBMISSION,
  props<{ submissionId: number; searchData: ISearchRequest }>(),
);

export const deleteAgentPayrollSubmissionSuccess = createAction(
  ActionTypes.DELETE_AGENT_PAYROLL_SUBMISSION_SUCCESS,
  props<{ data: any }>(),
);

export const deleteAgentPayrollSubmissionFailure = createAction(
  ActionTypes.DELETE_AGENT_PAYROLL_SUBMISSION_FAILURE,
  props<{ error: any }>(),
);

export const uploadAgentPayrollDocuments = createAction(
  ActionTypes.UPLOAD_AGENT_PAYROLL_DOCUMENTS,
  props<{ data: PayrollDocuments }>(),
);

export const uploadAgentPayrollDocumentsSuccess = createAction(
  ActionTypes.UPLOAD_AGENT_PAYROLL_DOCUMENTS_SUCCESS,
  props<{ data: any }>(),
);

export const uploadAgentPayrollDocumentsFailure = createAction(
  ActionTypes.UPLOAD_AGENT_PAYROLL_DOCUMENTS_FAILURE,
  props<{ error: any }>(),
);

export const clearPayrollSubmissionDetails = createAction(
  ActionTypes.CLEAR_PAYROLL_SUBMISSION_DETAILS,
);

export const deleteAgentPayrollAttachment = createAction(
  ActionTypes.DELETE_AGENT_PAYROLL_ATTACHMENT,
  props<{ attachmentId: number; submissionId: number }>(),
);

export const deleteAgentPayrollAttachmentSuccess = createAction(
  ActionTypes.DELETE_AGENT_PAYROLL_ATTACHMENT_SUCCESS,
  props<{ data: any }>(),
);

export const deleteAgentPayrollAttachmentFailure = createAction(
  ActionTypes.DELETE_AGENT_PAYROLL_ATTACHMENT_FAILURE,
  props<{ error: any }>(),
);

export const getAgentOffMarketProperties = createAction(
  ActionTypes.GET_AGENT_OFF_MARKET_PROPERTIES,
  props<{ data: ISearchRequest }>(),
);

export const getAgentOffMarketPropertiesSuccess = createAction(
  ActionTypes.GET_AGENT_OFF_MARKET_PROPERTIES_SUCCESS,
  props<{ data: any }>(),
);

export const getAgentOffMarketPropertiesFailure = createAction(
  ActionTypes.GET_AGENT_OFF_MARKET_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const getAgentOffMarketPropertyDetails = createAction(
  ActionTypes.GET_AGENT_OFF_MARKET_PROPERTY_DETAILS,
  props<{ id: number }>(),
);

export const getAgentOffMarketPropertyDetailsSuccess = createAction(
  ActionTypes.GET_AGENT_OFF_MARKET_PROPERTY_DETAILS_SUCCESS,
  props<{ data: OffMarketProperty }>(),
);

export const getAgentOffMarketPropertyDetailsFailure = createAction(
  ActionTypes.GET_AGENT_OFF_MARKET_PROPERTY_DETAILS_FAILURE,
  props<{ error: any }>(),
);

export const createAgentOffMarketProperty = createAction(
  ActionTypes.CREATE_AGENT_OFF_MARKET_PROPERTY,
  props<{ data: CreateOffMarketProperty }>(),
);

export const createAgentOffMarketPropertySuccess = createAction(
  ActionTypes.CREATE_AGENT_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const createAgentOffMarketPropertyFailure = createAction(
  ActionTypes.CREATE_AGENT_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const updateAgentOffMarketProperty = createAction(
  ActionTypes.UPDATE_AGENT_OFF_MARKET_PROPERTY,
  props<{ data: OffMarketProperty }>(),
);

export const updateAgentOffMarketPropertySuccess = createAction(
  ActionTypes.UPDATE_AGENT_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const updateAgentOffMarketPropertyFailure = createAction(
  ActionTypes.UPDATE_AGENT_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const deleteAgentOffMarketProperty = createAction(
  ActionTypes.DELETE_AGENT_OFF_MARKET_PROPERTY,
  props<{ id: number; data: ISearchRequest }>(),
);

export const deleteAgentOffMarketPropertySuccess = createAction(
  ActionTypes.DELETE_AGENT_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const deleteAgentOffMarketPropertyFailure = createAction(
  ActionTypes.DELETE_AGENT_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const uploadAgentOffMarketPropertyDocuments = createAction(
  ActionTypes.UPLOAD_AGENT_OFF_MARKET_PROPERTY_DOCUMENTS,
  props<{
    data: {
      propertyId: number;
      file: File;
      order: number;
    };
  }>(),
);

export const uploadAgentOffMarketPropertyDocumentsSuccess = createAction(
  ActionTypes.UPLOAD_AGENT_OFF_MARKET_PROPERTY_DOCUMENTS_SUCCESS,
  props<{ data: any }>(),
);

export const uploadAgentOffMarketPropertyDocumentsFailure = createAction(
  ActionTypes.UPLOAD_AGENT_OFF_MARKET_PROPERTY_DOCUMENTS_FAILURE,
  props<{ error: any }>(),
);

export const deleteAgentOffMarketPropertyDocument = createAction(
  ActionTypes.DELETE_AGENT_OFF_MARKET_PROPERTY_DOCUMENT,
  props<{ documentId: number; propertyId: number }>(),
);

export const deleteAgentOffMarketPropertyDocumentSuccess = createAction(
  ActionTypes.DELETE_AGENT_OFF_MARKET_PROPERTY_DOCUMENT_SUCCESS,
  props<{ data: any }>(),
);

export const deleteAgentOffMarketPropertyDocumentFailure = createAction(
  ActionTypes.DELETE_AGENT_OFF_MARKET_PROPERTY_DOCUMENT_FAILURE,
  props<{ error: any }>(),
);

export const generateAgentOffMarketPropertyShareLink = createAction(
  ActionTypes.GENERATE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK,
  props<{ propertyId: number }>(),
);

export const generateAgentOffMarketPropertyShareLinkSuccess = createAction(
  ActionTypes.GENERATE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS,
  props<{ data: any }>(),
);

export const generateAgentOffMarketPropertyShareLinkFailure = createAction(
  ActionTypes.GENERATE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE,
  props<{ error: any }>(),
);

export const revokeAgentOffMarketPropertyShareLink = createAction(
  ActionTypes.REVOKE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK,
  props<{ propertyId: number }>(),
);

export const revokeAgentOffMarketPropertyShareLinkSuccess = createAction(
  ActionTypes.REVOKE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_SUCCESS,
  props<{ data: any }>(),
);

export const revokeAgentOffMarketPropertyShareLinkFailure = createAction(
  ActionTypes.REVOKE_AGENT_OFF_MARKET_PROPERTY_SHARE_LINK_FAILURE,
  props<{ error: any }>(),
);

export const getSharedOffMarketProperty = createAction(
  ActionTypes.GET_SHARED_OFF_MARKET_PROPERTY,
  props<{ token: string }>(),
);

export const getSharedOffMarketPropertySuccess = createAction(
  ActionTypes.GET_SHARED_OFF_MARKET_PROPERTY_SUCCESS,
  props<{ data: OffMarketProperty }>(),
);

export const getSharedOffMarketPropertyFailure = createAction(
  ActionTypes.GET_SHARED_OFF_MARKET_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const createOrUpdateRentalListing = createAction(
  ActionTypes.CREATE_OR_UPDATE_RENTAL_LISTING,
  props<{ data: RentalListing }>(),
);

export const createOrUpdateRentalListingSuccess = createAction(
  ActionTypes.CREATE_OR_UPDATE_RENTAL_LISTING_SUCCESS,
  props<{ data: any }>(),
);

export const createOrUpdateRentalListingFailure = createAction(
  ActionTypes.CREATE_OR_UPDATE_RENTAL_LISTING_FAILURE,
  props<{ error: any }>(),
);

export const getRentalListings = createAction(
  ActionTypes.GET_RENTAL_LISTINGS,
  props<{ data: RentalListingsRequest }>(),
);

export const getRentalListingsSuccess = createAction(
  ActionTypes.GET_RENTAL_LISTINGS_SUCCESS,
  props<{ data: any }>(),
);

export const getRentalListingsFailure = createAction(
  ActionTypes.GET_RENTAL_LISTINGS_FAILURE,
  props<{ error: any }>(),
);

export const getRentalListingById = createAction(
  ActionTypes.GET_RENTAL_LISTING_BY_ID,
  props<{ id: number }>(),
);

export const getRentalListingByIdSuccess = createAction(
  ActionTypes.GET_RENTAL_LISTING_BY_ID_SUCCESS,
  props<{ data: any }>(),
);

export const getRentalListingByIdFailure = createAction(
  ActionTypes.GET_RENTAL_LISTING_BY_ID_FAILURE,
  props<{ error: any }>(),
);

export const getPublicRentalListingById = createAction(
  ActionTypes.GET_PUBLIC_RENTAL_LISTING_BY_ID,
  props<{ id: number; isLoading?: boolean }>(),
);

export const getPublicRentalListingByIdSuccess = createAction(
  ActionTypes.GET_PUBLIC_RENTAL_LISTING_BY_ID_SUCCESS,
  props<{ data: any }>(),
);

export const getPublicRentalListingByIdFailure = createAction(
  ActionTypes.GET_PUBLIC_RENTAL_LISTING_BY_ID_FAILURE,
  props<{ error: any }>(),
);

export const submitRentalForApproval = createAction(
  ActionTypes.SUBMIT_RENTAL_FOR_APPROVAL,
  props<{ id: number }>(),
);

export const submitRentalForApprovalSuccess = createAction(
  ActionTypes.SUBMIT_RENTAL_FOR_APPROVAL_SUCCESS,
  props<{ data: any; id: number }>(),
);

export const submitRentalForApprovalFailure = createAction(
  ActionTypes.SUBMIT_RENTAL_FOR_APPROVAL_FAILURE,
  props<{ error: any }>(),
);

export const deleteRentalListing = createAction(
  ActionTypes.DELETE_RENTAL_LISTING,
  props<{ id: number }>(),
);

export const deleteRentalListingSuccess = createAction(
  ActionTypes.DELETE_RENTAL_LISTING_SUCCESS,
  props<{ data: any; id: number }>(),
);

export const deleteRentalListingFailure = createAction(
  ActionTypes.DELETE_RENTAL_LISTING_FAILURE,
  props<{ error: any }>(),
);

export const startKycIdentitySession = createAction(
  ActionTypes.START_KYC_IDENTITY_SESSION,
);

export const startKycIdentitySessionSuccess = createAction(
  ActionTypes.START_KYC_IDENTITY_SESSION_SUCCESS,
  props<{ data: KycIdentitySessionResponse }>(),
);

export const startKycIdentitySessionFailure = createAction(
  ActionTypes.START_KYC_IDENTITY_SESSION_FAILURE,
  props<{ error: any }>(),
);

export const startKycProfilePolling = createAction(
  ActionTypes.START_KYC_PROFILE_POLLING,
);

export const stopKycProfilePolling = createAction(
  ActionTypes.STOP_KYC_PROFILE_POLLING,
);

export const checkKycProfileStatus = createAction(
  ActionTypes.CHECK_KYC_PROFILE_STATUS,
  props<{ attempt: number }>(),
);

export const checkKycProfileStatusSuccess = createAction(
  ActionTypes.CHECK_KYC_PROFILE_STATUS_SUCCESS,
  props<{ kycCompleted: boolean; kycStatus: string | null }>(),
);

export const checkKycProfileStatusFailure = createAction(
  ActionTypes.CHECK_KYC_PROFILE_STATUS_FAILURE,
  props<{ error: any }>(),
);

export const kycProfilePollingTimedOut = createAction(
  ActionTypes.KYC_PROFILE_POLLING_TIMED_OUT,
);

export const clearKycProfilePollingState = createAction(
  ActionTypes.CLEAR_KYC_PROFILE_POLLING_STATE,
);

export const setPendingRentalSubmitAfterKyc = createAction(
  ActionTypes.SET_PENDING_RENTAL_SUBMIT_AFTER_KYC,
  props<{ id: number | null }>(),
);

export const searchRentalProperties = createAction(
  ActionTypes.SEARCH_RENTAL_PROPERTIES,
  props<{ data: RentalSearchRequest }>(),
);

export const searchRentalPropertiesSuccess = createAction(
  ActionTypes.SEARCH_RENTAL_PROPERTIES_SUCCESS,
  props<{ data: any }>(),
);

export const searchRentalPropertiesFailure = createAction(
  ActionTypes.SEARCH_RENTAL_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const getRentalMapMarkers = createAction(
  ActionTypes.GET_RENTAL_MAP_MARKERS,
  props<{ data: RentalSearchRequest }>(),
);

export const getRentalMapMarkersSuccess = createAction(
  ActionTypes.GET_RENTAL_MAP_MARKERS_SUCCESS,
  props<{ data: any }>(),
);

export const getRentalMapMarkersFailure = createAction(
  ActionTypes.GET_RENTAL_MAP_MARKERS_FAILURE,
  props<{ error: any }>(),
);

export const getArisMarketedProperties = createAction(
  ActionTypes.GET_ARIS_MARKETED_PROPERTIES,
  props<{ data: PropertySearch }>(),
);

export const getArisMarketedPropertiesSuccess = createAction(
  ActionTypes.GET_ARIS_MARKETED_PROPERTIES_SUCCESS,
  props<{ data: MarketedPropertyListing[] }>(),
);

export const getArisMarketedPropertiesFailure = createAction(
  ActionTypes.GET_ARIS_MARKETED_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const getArisMarketedMapProperties = createAction(
  ActionTypes.GET_ARIS_MARKETED_MAP_PROPERTIES,
  props<{ data: Partial<MapPropertySearchParams> }>(),
);

export const getArisMarketedMapPropertiesSuccess = createAction(
  ActionTypes.GET_ARIS_MARKETED_MAP_PROPERTIES_SUCCESS,
  props<{ data: MarketedPropertyListing[] }>(),
);

export const getArisMarketedMapPropertiesFailure = createAction(
  ActionTypes.GET_ARIS_MARKETED_MAP_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);
